import React from 'react';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  ChartBarIcon,
  BuildingOffice2Icon,
  Square3Stack3DIcon,
  CircleStackIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';

const NAV = [
  { name: 'Overview', href: '/overview', icon: ChartBarIcon },
  { name: 'Tenants', href: '/tenants', icon: BuildingOffice2Icon },
  { name: 'Plans', href: '/plans', icon: Square3Stack3DIcon },
  { name: 'Backups', href: '/backups', icon: CircleStackIcon },
];

const PlatformLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex">
      <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
        <div className="h-16 flex items-center px-6 border-b border-gray-200">
          <div className="h-8 w-8 bg-primary-600 rounded-lg flex items-center justify-center mr-3">
            <span className="text-white font-bold text-sm">CT</span>
          </div>
          <span className="font-semibold text-gray-900">Platform Admin</span>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map((item) => {
            const isActive = location.pathname.startsWith(item.href);
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? 'bg-primary-50 text-primary-700' : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <item.icon className="h-5 w-5 mr-3" />
                {item.name}
              </Link>
            );
          })}
        </nav>

        <div className="p-3 border-t border-gray-200">
          <div className="px-3 py-2 text-sm">
            <div className="font-medium text-gray-900">{user?.name}</div>
            <div className="text-gray-500 text-xs">{user?.email}</div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-100"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5 mr-3" />
            Logout
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default PlatformLayout;
